package com.eladfinish.bible.contest.screens.randomVerse

import androidx.compose.ui.text.TextRange
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.analytics.AnalyticsConstants
import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.analytics.providers.AnalyticsProvider
import com.eladfinish.bible.contest.arch.ViewModelStore
import com.eladfinish.bible.contest.at_least_one_book
import com.eladfinish.bible.contest.common.ChaptersRepository
import com.eladfinish.bible.contest.common.ChaptersRepository.Companion.migrateFilename
import com.eladfinish.bible.contest.common.usecases.PartitionChapterUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveTeamimUseCase
import com.eladfinish.bible.contest.common.usecases.VersePickTarget
import com.eladfinish.bible.contest.constants.BooleanConstants.ENABLE_CHAPTER_IDENTIFYING_TASK
import com.eladfinish.bible.contest.constants.BooleanConstants.ENABLE_SHOW_WITH_TEAMIM_PREF
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.constants.Constants.PREF_SHOW_WITH_TEAMIM
import com.eladfinish.bible.contest.constants.NUMBER_OF_BOOKS
import com.eladfinish.bible.contest.constants.NUMBER_OF_CHAPTERS
import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_ENABLE_CHAPTER_IDENTIFYING_TASK
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_ENABLE_HALF_VERSE
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_ENABLE_PARASHA_IDENTIFYING_TASK
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.constants.StringConstants.ALL_CHAPTERS
import com.eladfinish.bible.contest.constants.StringConstants.COLON_SPLITTER
import com.eladfinish.bible.contest.constants.strings.CommonVerses.VAYDABER_LEMOR
import com.eladfinish.bible.contest.constants.strings.CommonVerses.VAYHI_DEVAR_EL
import com.eladfinish.bible.contest.constants.strings.CommonVerses.VAYHI_DEVAR_ELAY
import com.eladfinish.bible.contest.constants.strings.CommonVerses.VAYOMER_HASHEM
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.data.common.MyClipboardManager
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.domain.BooksRepository.numOfChaptersPerBook
import com.eladfinish.bible.contest.domain.catalog.BibleCatalog.books
import com.eladfinish.bible.contest.domain.catalog.BookData
import com.eladfinish.bible.contest.extensions.makeContinuousUnderlinedKMP
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.extensions.runIf
import com.eladfinish.bible.contest.features.verseWidget.VerseWidgetPromptGate
import com.eladfinish.bible.contest.features.verseWidget.VerseWidgetPromptReporter
import com.eladfinish.bible.contest.features.verseWidget.VerseWidgetPromptSession
import com.eladfinish.bible.contest.iyov
import com.eladfinish.bible.contest.models.ClickableTextData
import com.eladfinish.bible.contest.pirkei
import com.eladfinish.bible.contest.screens.mikud.MikudRepository
import com.eladfinish.bible.contest.screens.mikud.model.mikudItem
import com.eladfinish.bible.contest.screens.mikud.usecases.GetRandomBookRandomChapterFilenameUseCase
import com.eladfinish.bible.contest.screens.mikud.usecases.PickRandomChapterUseCase
import com.eladfinish.bible.contest.screens.randomVerse.RandomVerseState.BottomSheetState
import com.eladfinish.bible.contest.screens.randomVerse.model.RandomVersePart
import com.eladfinish.bible.contest.screens.randomVerse.model.RandomizedVerse
import com.eladfinish.bible.contest.screens.randomVerse.usecases.BuildChapterDialogFromVerse
import com.eladfinish.bible.contest.screens.randomVerse.usecases.GetNamesToHideUseCase
import com.eladfinish.bible.contest.screens.randomVerse.usecases.HidePeopleNamesUsecase
import com.eladfinish.bible.contest.screens.randomVerse.usecases.ShowIyovFriendsUseCase
import com.eladfinish.bible.contest.screens.randomVerse.usecases.ShowSubTopicsUseCase
import com.eladfinish.bible.contest.screens.randomVerse.usecases.SubTopicsData
import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import com.eladfinish.bible.contest.screens.search.usecases.PickVerseFromChapterUseCaseV2
import com.eladfinish.bible.contest.text.SpanType
import com.eladfinish.bible.contest.text.SpannableStringKMP
import com.eladfinish.bible.contest.text.SpannedRange
import com.eladfinish.bible.contest.ui.menus.actions.RandomVerseToolbarAction
import com.eladfinish.bible.contest.utils.GetParashotUseCase
import com.eladfinish.bible.contest.utils.MyStringUtils
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.addGershaimAndColon
import com.eladfinish.bible.contest.utils.gematriaWord
import com.eladfinish.bible.contest.utils.getOtiot
import com.eladfinish.bible.contest.utils.replaceKtivWithQriNew
import com.eladfinish.bible.contest.utils.setNoBreakSpaceBeforePasek
import com.eladfinish.bible.contest.utils.toOtiot
import com.russhwolf.settings.ExperimentalSettingsApi
import com.russhwolf.settings.ObservableSettings
import com.russhwolf.settings.Settings
import com.russhwolf.settings.coroutines.getStringFlow
import dev.icerock.moko.resources.desc.desc
import io.github.aakira.napier.Napier
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toImmutableList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.withContext
import kotlin.random.Random
import kotlin.time.Duration.Companion.milliseconds

class RandomVerseStore(
    private val randomVerseStoreParams: RandomVerseStoreParams,
    private val settings: Settings,
    private val observableSettings: ObservableSettings,
    private val stringResolver: StringResolver,
    private val assetReader: AssetReader,
    private val mikudRepository: MikudRepository,
    private val analyticsProvider: AnalyticsProvider,
    private val myClipboardManager: MyClipboardManager,
    private val showIyovFriendsUseCase: ShowIyovFriendsUseCase,
    private val showSubTopicsUseCase: ShowSubTopicsUseCase,
    private val hidePeopleNamesUsecase: HidePeopleNamesUsecase,
    private val getParashotUseCase: GetParashotUseCase,
    private val partitionChapterUseCase: PartitionChapterUseCase,
    private val removeTeamimUseCase: RemoveTeamimUseCase,
    private val pickVerseFromChapterUseCaseV2: PickVerseFromChapterUseCaseV2,
    private val pickRandomChapterUseCase: PickRandomChapterUseCase,
    private val getRandomBookRandomChapterFilenameUseCase: GetRandomBookRandomChapterFilenameUseCase,
    private val getNamesToHideUseCase: GetNamesToHideUseCase,
    private val buildChapterDialogFromVerse: BuildChapterDialogFromVerse,
    private val verseWidgetPromptGate: VerseWidgetPromptGate,
    private val verseWidgetPromptSession: VerseWidgetPromptSession,
    private val verseWidgetPromptReporter: VerseWidgetPromptReporter,
) : ViewModelStore<RandomVerseState, RandomVerseAction, RandomVerseEffect>(
    tag = "RandomVerseStore",
) {

    companion object {
        //        const val skipReadMePref = "skipReadMeRandomVerse"
        const val MULTIPLE_RANDOM_VERSES_SIZE = 10

        data class RandomVerseStoreParams(
            val enableHalfVerseDefault: Boolean,
            val enableParashaIdentifyingTask: Boolean,
        )

        /** Placeholder used while no verse has been loaded yet. */
        val EMPTY_VERSE_UI_MODEL = VerseUiModel(
            id = "empty",
            text = "",
            source = "",
            highlightedRanges = kotlinx.collections.immutable.persistentListOf(),
            bookIndex = 0,
            chapterIndex = 0,
            verse = "",
        )
    }

    private val defaultState: RandomVerseState
        get() = RandomVerseState(
            verseUiModel = null,
            randomizedVerse = RandomizedVerse(verseUiModel = EMPTY_VERSE_UI_MODEL),
            bookItems = buildBookItems(bibleBooksInMikud),
            shownPart = null,
            dialogState = RandomVerseState.DialogState.None,
            bottomSheetState = BottomSheetState.Hidden,
            isShakeEnabled = isShakeEnabled,
        )

    @ExperimentalCoroutinesApi
    override val stateFlow = MutableStateFlow(defaultState)

    private var chapterContent = ""
    private var namesToHide: StringBuilder = StringBuilder()

    init {
        launchEffect {
            listenToMikud()
        }
    }

    private fun currentPrefsFingerprint(): Int =
        listOf(
            isShakeEnabled,
            shouldShowFullChapter,
            isAlphabeticalOrder,
            isChapterIdentifyingTaskEnabled,
            randomApproach,
            settings.getBoolean(key = SharedPrefsConstants.ONLY_QRI_SWITCH, defaultValue = true),
            settings.getBoolean(key = Constants.PREF_HIDE_PEOPLE_NAMES_SWITCH, defaultValue = true),
            settings.getBoolean(key = Constants.PREF_NIKUD_SWITCH, defaultValue = true),
            settings.getBoolean(key = PREF_SHOW_WITH_TEAMIM, defaultValue = ENABLE_SHOW_WITH_TEAMIM_PREF),
            settings.getBoolean(key = KEY_ENABLE_HALF_VERSE, defaultValue = randomVerseStoreParams.enableHalfVerseDefault),
        ).hashCode()

    @OptIn(ExperimentalSettingsApi::class)
    private suspend fun listenToMikud() {
        observableSettings.getStringFlow(
            key = Constants.PREF_BIBLE_BOOKS_IN_MIKUD,
            defaultValue = "[]"
        ).collect { newBooksInMikud ->
            updateState {
                it.copy(
                    bookItems = buildBookItems(bibleBooksInMikud = newBooksInMikud)
                )
            }
            launchEffect {
                delay(50.milliseconds)
                getRandomVerse(onEmptyMikud = { notifyEmptyMikud() })
            }
        }
    }

    override fun handleAction(action: RandomVerseAction): RandomVerseState =
        when (action) {
            is RandomVerseAction.ToolbarClicked -> handleToolbarClicked(action.toolbarAction)
            RandomVerseAction.HideDialog -> handleHideDialog()
            RandomVerseAction.HideBottomSheet -> handleHideBottomSheet()

            RandomVerseAction.MikudClicked -> currentState
            RandomVerseAction.MultipleRandomVersesClicked -> currentState
            RandomVerseAction.ParchmentClicked -> currentState
            RandomVerseAction.Refresh -> currentState
            RandomVerseAction.SettingsClicked -> currentState
            RandomVerseAction.DeviceIsShaken -> {
                handleDeviceIsShaken()
            }

            is RandomVerseAction.BookClicked -> {
                handleBookClicked(action.name)
            }

            RandomVerseAction.WrongAnswerChosen -> {
                onlyEffect(RandomVerseEffect.NotifyWrongAnswer)
            }

            RandomVerseAction.VerseLongClicked -> {
                val text = currentState.randomizedVerse.fullSpannableStringKMP.charSequence.toString()
                myClipboardManager.copyToClipboard(text)
                onlyEffect(RandomVerseEffect.CopyToClipboard(text))
            }

            is RandomVerseAction.ChapterClicked -> {
                handleChapterClicked(action.isCorrect)
            }

            RandomVerseAction.VerseClicked -> {
                handleVerseClicked()
            }

            RandomVerseAction.RefreshAfterSettings -> {
                handleRefreshAfterSettings()
            }

            RandomVerseAction.WidgetPromptDismissed -> handleWidgetPromptDismissed()
            RandomVerseAction.WidgetPromptClicked -> handleWidgetPromptClicked()
        }

    private fun handleWidgetPromptDismissed(): RandomVerseState {
        if (!currentState.isWidgetPromptVisible) return currentState
        verseWidgetPromptReporter.onDismissed(shownCount = verseWidgetPromptGate.shownCount())
        return currentState.copy(isWidgetPromptVisible = false)
    }

    /** Only the hint's part; the screen then opens the widget screen the way the home tile does. */
    private fun handleWidgetPromptClicked(): RandomVerseState {
        if (!currentState.isWidgetPromptVisible) return currentState
        verseWidgetPromptReporter.onCta(shownCount = verseWidgetPromptGate.shownCount())
        // Whatever the user does on the widget screen, the hint has done its job
        verseWidgetPromptGate.markDone()
        launchEffect { sideEffectFlow.emit(RandomVerseEffect.OpenVerseWidget) }
        return currentState.copy(isWidgetPromptVisible = false)
    }

    /**
     * A verse was put on the screen. After a few of them in a session the hint that offers the widget may appear (and,
     * once it is there, it stays through the next verses until it is dismissed or the screen is left).
     */
    private fun offerWidgetPromptIfDue() {
        verseWidgetPromptSession.onVerseViewed()
        if (currentState.isWidgetPromptVisible) return
        val isScreenBusy = currentState.dialogState != RandomVerseState.DialogState.None ||
            currentState.bottomSheetState != BottomSheetState.Hidden
        if (!verseWidgetPromptGate.shouldShow(isScreenBusy = isScreenBusy)) return

        val shownCount = verseWidgetPromptGate.markShown()
        verseWidgetPromptReporter.onShown(shownCount = shownCount, versesViewed = verseWidgetPromptSession.versesViewed)
        updateState { it.copy(isWidgetPromptVisible = true) }
    }

    private fun handleRefreshAfterSettings(): RandomVerseState {
        val newFingerprint = currentPrefsFingerprint()
        if (newFingerprint == currentState.prefsFingerprint) {
            return currentState
        }

        val updatedState = currentState.copy(
            prefsFingerprint = newFingerprint,
            bookItems = buildBookItems(bibleBooksInMikud = bibleBooksInMikud),
            isShakeEnabled = isShakeEnabled,
            dialogState = RandomVerseState.DialogState.None,
            bottomSheetState = BottomSheetState.Hidden,
        )

//        updateState { updatedState }

        getRandomVerse(
            onEmptyMikud = { notifyEmptyMikud() },
        )

        return updatedState
    }

    private fun notifyEmptyMikud() {
        launchEffect {
            sideEffectFlow.emit(RandomVerseEffect.NotifyEmptyMikud)
        }
    }

    private fun handleVerseClicked(): RandomVerseState {
        return when (currentState.shownPart) {
            RandomVersePart.HALF -> currentState.copy(shownPart = RandomVersePart.FULL)
            RandomVersePart.FULL -> {
                if (shouldShowFullChapter && numOfChaptersInMikud != 0) {
                    launchEffect {
                        withContext(Dispatchers.Default) {
                            updateState {
                                val verseUiModel = it.verseUiModel!!
                                val parasha = it.randomizedVerse.parasha
                                it.copy(
                                    dialogState = RandomVerseState.DialogState.ChapterDialog(
                                        chapterData = buildChapterDialogFromVerse(
                                            verseUiModel = verseUiModel,
                                            parasha = parasha,
                                            namesToHide = namesToHide,
                                        )
                                    )
                                )
                            }
                        }
                    }
                    currentState
                } else {
                    currentState
                }
            }

            null -> currentState
        }
    }

    private fun handleChapterClicked(correct: Boolean): RandomVerseState {
        Napier.d("handleChapterClicked correct - $correct")
        return if (correct) {
            launchEffect { sideEffectFlow.emit(RandomVerseEffect.NotifyCorrectAnswerOnChapter) }
            getRandomVerse(onEmptyMikud = { notifyEmptyMikud() })
            currentState.copy(bottomSheetState = BottomSheetState.Hidden)
        } else {
            onlyEffect(RandomVerseEffect.NotifyWrongAnswerOnChapter)
        }
    }

    private fun handleHideDialog(): RandomVerseState {
        return currentState.copy(dialogState = RandomVerseState.DialogState.None)
    }

    private fun handleHideBottomSheet(): RandomVerseState {
        return currentState.copy(bottomSheetState = BottomSheetState.Hidden)
    }

    private fun handleDeviceIsShaken(): RandomVerseState {
        launchEffect {
            sideEffectFlow.emit(RandomVerseEffect.DismissSnackbar)
        }
        getRandomVerse(onEmptyMikud = { notifyEmptyMikud() })
        return currentState.copy(bottomSheetState = BottomSheetState.Hidden)
    }

    private fun handleBookClicked(name: String): RandomVerseState {
        val isCorrect = name == bookName(currentState.randomizedVerse.verseUiModel.bookIndex)

        if (!isCorrect) {
            return onlyEffect(RandomVerseEffect.NotifyWrongAnswer)
        }

        launchEffect { sideEffectFlow.emit(RandomVerseEffect.NotifyCorrectAnswer) }

        if (isChapterIdentifyingTaskEnabled) {
            val chapterList = getChapterList(
                onCorrectChapter = {
                    dispatch(RandomVerseAction.ChapterClicked(isCorrect = it))
                }
            )
            return currentState.copy(bottomSheetState = BottomSheetState.ChapterPicker(content = chapterList))
        }

        // Not in chapter task -> generate next verse (like makeRandom())
        launchEffect {
            getRandomVerse(onEmptyMikud = { notifyEmptyMikud() })
        }

        return currentState
    }

    private fun handleToolbarClicked(toolbarAction: RandomVerseToolbarAction): RandomVerseState {
        return when (toolbarAction) {
            RandomVerseToolbarAction.NewVerse -> {
                getRandomVerse(onEmptyMikud = { notifyEmptyMikud() })
                currentState
            }

            RandomVerseToolbarAction.SeveralRandomVerses -> {
                analyticsProvider.logEvent(AnalyticsConstants.SEVERAL_RANDOM_VERSES)
                onlyEffect(RandomVerseEffect.OpenSeveralRandomVerses)
            }

            RandomVerseToolbarAction.Settings -> {
                analyticsProvider.logEvent(AnalyticsConstants.RANDOM_VERSE_SETTINGS)
                onlyEffect(RandomVerseEffect.OpenRandomVerseSettings)
            }
        }
    }

    private val numOfChaptersInMikud
        get() = settings.getInt(Constants.PREF_NUM_OF_CHAPTERS_IN_MIKUD, NUMBER_OF_CHAPTERS) // 929

    private val isShakeEnabled: Boolean
        get() = settings.getBoolean(key = Constants.PREF_ENABLE_SHAKE_SWITCH, defaultValue = true)

    private val shouldShowFullChapter: Boolean
        get() = settings.getBoolean(key = Constants.PREF_SHOW_FULL_CHAPTER_SWITCH, defaultValue = true)

    private val isAlphabeticalOrder: Boolean
        get() = settings.getBoolean(key = Constants.PREF_ALPHABETICAL_SWITCH, defaultValue = false)

    private val bibleBooksInMikud: String
        get() = settings.getString(key = Constants.PREF_BIBLE_BOOKS_IN_MIKUD, defaultValue = "[]")

    private val isChapterIdentifyingTaskEnabled: Boolean
        get() = settings.getBoolean(
            key = KEY_ENABLE_CHAPTER_IDENTIFYING_TASK,
            defaultValue = ENABLE_CHAPTER_IDENTIFYING_TASK
        )

    private val randomApproach: String
        get() = settings.getString(key = Constants.PREF_RANDOM_APPROACH, defaultValue = Constants.APPROACH_BY_BOOK)

    private fun buildBookItems(bibleBooksInMikud: String): ImmutableList<Pair<BookData, Boolean>> {
        val booksInMikud: List<Boolean>
        var booksInMikudStr = bibleBooksInMikud
        if (booksInMikudStr == "[]") {
            booksInMikud = MutableList(NUMBER_OF_BOOKS) { true }
        } else {
            booksInMikudStr = booksInMikudStr.replaceRegex(regex = "[\\[\\] ]", replacement = "")
            booksInMikud = booksInMikudStr.split(",").map { it.toBoolean() }
        }
        val bookDataList = books
        val enabledList = MutableList(bookDataList.size) { booksInMikud[it] }
        return (listOf(mikudItem to true) +
                bookDataList.zip(enabledList).runIf(isAlphabeticalOrder) {
                    sortedBy { it.first.hebrew }
                }).toImmutableList()
    }

    private fun getPartitionedVerse(verseUiModel: VerseUiModel, rawContent: String): String {
        val verse = "${verseUiModel.verse} $rawContent$COLON_SPLITTER"
        val book = bookName(verseUiModel.bookIndex)
        val fromSifreyEmet = MyStringUtils.isFromSifreyEmet(book)
        val partitioned = partitionChapterUseCase(chapter = verse, isFromSifreyEmet = fromSifreyEmet)
        val firstArray = partitioned[0]
        val partsArray = firstArray.subList(fromIndex = 1, toIndex = firstArray.size)
        Napier.d("partsArray: $partsArray")
        try {

            val size = partsArray.size
            val num = Random.nextInt(partsArray.size)
            var part = MyStringUtils.retrieveVerse(partsArray[num])
            Napier.d("part: $part")

            val ellipsis = "..." // "…"
            if (size == 3 && num == 1) {
                if (partsArray[1].size == 1) {
                    part = "$ellipsis $part ${MyStringUtils.retrieveVerse(partsArray[2])}"
                } else {
                    part += " $ellipsis "
                }
            } else if (num == 0) {
                part = "$part $ellipsis "
            } else {
                part = "$ellipsis $part"
            }
            return part
        } catch (e: Exception) {
            AppCrashlytics.logException(e)
        }
        return "---"
    }

    private fun setupPrefsOnVerse(
        randomVerseContentParam: String,
        chapterFilename: String,
        parasha: String,
        namesToHide: StringBuilder,
    ): String = randomVerseContentParam
        .showOnlyQriIfNeeded()
        .hideNamesIfNeeded(chapterFilename, parasha, namesToHide)
        .hideNikudIfNeeded()
        .hideTeamimIfNeeded()

    private fun String.showOnlyQriIfNeeded(): String {
        var randomVerseContent = this
        if (settings.getBoolean(SharedPrefsConstants.ONLY_QRI_SWITCH, true)) {
            randomVerseContent = randomVerseContent.replaceKtivWithQriNew()
        }
        return randomVerseContent
    }

    private fun String.hideNamesIfNeeded(
        chapterFilename: String,
        parasha: String,
        namesToHide: StringBuilder,
    ): String {
        namesToHide.append("שמות להסרה:")
        var randomVerseContent = this
        if (settings.getBoolean(Constants.PREF_HIDE_PEOPLE_NAMES_SWITCH, true)) {
            val namesToHideList = getNamesToHideUseCase(
                chapterFilename = chapterFilename,
                parasha = parasha,
                namesToHide = namesToHide,
            )
            Napier.d("namesToHide $namesToHideList")
            randomVerseContent = hidePeopleNamesUsecase.getVerseWithHiddenNames(
                names = namesToHideList,
                randomVerseStr = randomVerseContent,
            ).verseWithBlanks
        }
        return randomVerseContent
    }

    private fun String.hideNikudIfNeeded(): String {
        var randomVerseContent = this
        if (!settings.getBoolean(Constants.PREF_NIKUD_SWITCH, true)) {
            randomVerseContent = randomVerseContent.replaceRegex(regex = StringConstants.Regex.NIKUD_CHARS, replacement = "")
        }
        return randomVerseContent
    }

    private fun String.hideTeamimIfNeeded(): String {
        var randomVerseContent = this
        if (!settings.getBoolean(key = PREF_SHOW_WITH_TEAMIM, defaultValue = ENABLE_SHOW_WITH_TEAMIM_PREF)) {
            randomVerseContent = removeTeamimUseCase(pasuk = randomVerseContent)
        }
        return randomVerseContent
    }

    private fun getRandomVerse(
        onEmptyMikud: () -> Unit,
    ): RandomizedVerse {
        if (numOfChaptersInMikud == 0) {
            onEmptyMikud.invoke()
            return RandomizedVerse(
                verseUiModel = errorVerseUiModel(
                    stringResolver.resolveString(SharedRes.strings.at_least_one_book.desc())
                )
            )
        }

        val chapterFilename: String
        val bookIndex: Int
        // choose book and then chapter
        try {
            val mikudStr = mikudRepository.mikudList
            if (mikudStr.isEmpty()) {
                return RandomizedVerse(
                    verseUiModel = errorVerseUiModel(
                        stringResolver.resolveString(SharedRes.strings.at_least_one_book.desc())
                    )
                )
            }
            chapterFilename =
                if (randomApproach == Constants.APPROACH_BY_BOOK) {
                    getRandomBookRandomChapterFilenameUseCase(mikudStr = mikudStr)
                } else { // choose chapter
                    pickRandomChapterUseCase(chapterList = mikudStr)
                }
                    .migrateFilename()
            chapterContent = assetReader.readFile(fileName = ALL_CHAPTERS + assetReader.fileSeparator + chapterFilename)
            bookIndex = ChaptersRepository.getBookNumber(chapterFilename)
        } catch (e: Exception) {
            chapterContent = "error: " + e.message
            AppCrashlytics.logException(e)
            return RandomizedVerse(verseUiModel = errorVerseUiModel(chapterContent))
        }
        var verseUiModel: VerseUiModel?
        var hasIdenticalVerse: Boolean
        do {
            hasIdenticalVerse = false
            verseUiModel = pickVerseFromChapterUseCaseV2(
                bookIndex = bookIndex,
                chapterContent = chapterContent,
                target = VersePickTarget.Random,
            )!!
            updateState {
                it.copy(verseUiModel = verseUiModel)
            }
            // rawContent = verse text without gershaim/colon wrapping
            val rawContent = verseUiModel.rawContent()
            val rawContentNoTeamim = rawContent
                .replaceRegex(regex = StringConstants.Regex.TEAMIM_CHARS, replacement = "")
                .replaceRegex(regex = "\\s+", replacement = " ")
            if (listOf(
                    VAYDABER_LEMOR,
                    VAYHI_DEVAR_EL,
                    VAYOMER_HASHEM,
                ).map { it.toRegex() }.any {
                    rawContentNoTeamim.matches(it)
                }
                || rawContent == VAYHI_DEVAR_ELAY
            ) {
                Napier.d(verseUiModel.toString())
                Napier.d("הפסוק מופיע בספרים שונים ולכן אין להגרילו!")
                hasIdenticalVerse = true
            }
        } while (hasIdenticalVerse)

        val rawContent = verseUiModel.rawContent()
        val parasha = getParashotUseCase.getParashaByBookChapterAndVerse(
            book = bookName(bookIndex),
            chapter = verseUiModel.chapterIndex.toOtiot(),
            verse = verseUiModel.verse,
        )

        val fullSpannable = stylizeVerse(
            randomVerseContentParam = rawContent,
            chapterFilename = chapterFilename,
            parasha = parasha,
        )

        val halfSpannable: SpannableStringKMP = stylizeVerse(
            randomVerseContentParam = getPartitionedVerse(verseUiModel, rawContent),
            chapterFilename = chapterFilename,
            parasha = parasha,
        )

        val randomVersePart: RandomVersePart = if (settings.getBoolean(
                key = KEY_ENABLE_HALF_VERSE,
                defaultValue = randomVerseStoreParams.enableHalfVerseDefault,
            )
        ) {
            RandomVersePart.HALF
        } else {
            RandomVersePart.FULL
        }

        return RandomizedVerse(
            verseUiModel = verseUiModel,
            rawContent = rawContent,
            parasha = parasha,
            halfSpannableStringKMP = halfSpannable,
            fullSpannableStringKMP = fullSpannable,
        ).also {
            updateState { state ->
                state.copy(
                    randomizedVerse = it,
                    shownPart = randomVersePart,
                )
            }
            offerWidgetPromptIfDue()
        }
    }

    private fun stylizeVerse(
        randomVerseContentParam: String,
        chapterFilename: String,
        parasha: String,
    ): SpannableStringKMP {
        namesToHide = StringBuilder()
        return setupPrefsOnVerse(randomVerseContentParam, chapterFilename, parasha, namesToHide)
            .setNoBreakSpaceBeforePasek()
            .addGershaimAndColon()
            .makeContinuousUnderlinedKMP()
    }

    private fun showParashotList(
        sb: StringBuilder,
        onCorrectChapter: (Boolean) -> Unit,
    ): List<SpannedRange> {
        val verseUiModel = currentState.verseUiModel!!
        val spannedRangeList = mutableListOf<SpannedRange>()
        val parashot = getParashotUseCase.parseParashot(bookNumber = verseUiModel.bookIndex, connected = false)
        sb.append("\n")
        sb.append("פרשות בחומש ").append(bookName(verseUiModel.bookIndex)).append(":\n")
        val parashotNames = parashot.parashotNames

        for (i in parashotNames.indices) {
            val parasha = parashotNames[i].replaceRegex(regex = " ", replacement = StringConstants.NO_BREAK_SPACE)
            sb.append(parasha)

            spannedRangeList.add(
                SpannedRange(
                    spanType = SpanType.ClickableLegacy {
                        //check if the random verse is inside the clicked parasha
                        val actualParasha =
                            currentState.randomizedVerse.parasha.replaceRegex(regex = " ", replacement = StringConstants.NO_BREAK_SPACE)
                        val insideParasha = actualParasha == parasha
                        onCorrectChapter(insideParasha)
                    },
                    textRange = TextRange(start = sb.length - parasha.length, end = sb.length)
                )
            )
            sb.append(StringConstants.FIVE_SPACES)
        }
        sb.deleteRange(sb.length - StringConstants.FIVE_SPACES.length, sb.length - 1)
        return spannedRangeList
    }

    private fun getChapterList(
        onCorrectChapter: (Boolean) -> Unit,
    ): SpannableStringKMP {
        val spannedRangeList = mutableListOf<SpannedRange>()
        val verseUiModel = currentState.verseUiModel!!
        val book = bookName(verseUiModel.bookIndex)
        val chapter = verseUiModel.chapterIndex.toOtiot()
        val bookI = verseUiModel.bookIndex - 1
        val n: Int = numOfChaptersPerBook[bookI]
        val title: String = stringResolver.resolveString(SharedRes.strings.pirkei.desc()) + ' ' + book + ":\n"
        val sb = StringBuilder(title)
        for (i in 1..n) {
            val ot = getOtiot(i)
            val withGershaim = ot.addGershaim()
            sb.append(withGershaim)

            spannedRangeList.add(
                SpannedRange(
                    spanType = SpanType.ClickableLegacy {
                        onCorrectChapter(chapter == ot)
                    },
                    textRange = TextRange(start = sb.length - withGershaim.length, end = sb.length)
                )
            )

            sb.append(StringConstants.FIVE_SPACES)
        }
        sb.deleteRange(sb.length - StringConstants.FIVE_SPACES.length, sb.length - 1)
        val sb2 = StringBuilder()
        val currentChapter = verseUiModel.chapterIndex
        val currentPasuk = verseUiModel.verse.gematriaWord()
        val specialSpannedRangeList = mutableListOf<SpannedRange>()
        when (book) {
            stringResolver.resolveString(SharedRes.strings.iyov.desc()) -> {
                sb.append("\n")
                showIyovFriendsUseCase.showIyovFriends(
                    currentChapter = currentChapter,
                    currentPasuk = currentPasuk,
                    onCorrectChapter = onCorrectChapter,
                ).let {
                    val clickableAreas = applyClickableAreas(
                        stringBuilder = sb2,
                        clickableTextData = it,
                    )
                    specialSpannedRangeList.addAll(clickableAreas)
                }
            }

            else -> {
                if (showSubTopicsUseCase.shouldShowSubTopics(book)) {
                    showSubTopicsUseCase.showSubTopicsInBook(
                        data = showSubTopicsUseCase.bookToSubTopicsData(book).let { (name, jsonString) ->
                            SubTopicsData(title = name, jsonTopics = jsonString)
                        },
                        currentChapter = currentChapter,
                        currentPasuk = currentPasuk,
                        onCorrectChapter = onCorrectChapter,
                    ).let {
                        val clickableAreas = applyClickableAreas(
                            stringBuilder = sb2,
                            clickableTextData = it,
                        )
                        specialSpannedRangeList.addAll(clickableAreas)
                    }
                }
            }
        }
        sb.insert(0, sb2)
        if (settings.getBoolean(
                key = KEY_ENABLE_PARASHA_IDENTIFYING_TASK,
                defaultValue = randomVerseStoreParams.enableParashaIdentifyingTask,
            )
        ) {
            if (bookI < 5) { // if book is from 5 chumashim of the torah
                val spannedRangeParashotList = showParashotList(
                    sb = sb,
                    onCorrectChapter = onCorrectChapter,
                )
                spannedRangeList.addAll(spannedRangeParashotList)
            }
        }
        return SpannableStringKMP(
            charSequence = sb.toString(),
            spannedRangeList = (specialSpannedRangeList +
                    spannedRangeList.map {
                        it.copy(
                            textRange = TextRange(
                                start = it.textRange.start + sb2.length,
                                end = it.textRange.end + sb2.length
                            )
                        )
                    }).toImmutableList()
        )
    }

    private fun applyClickableAreas(
        stringBuilder: StringBuilder,
        clickableTextData: ClickableTextData,
    ): List<SpannedRange> {
        val spannedRangeList = mutableListOf<SpannedRange>()
        stringBuilder.append(clickableTextData.text)
        clickableTextData.clickableAreas.forEach { clickableArea ->
            spannedRangeList.add(
                SpannedRange(
                    spanType = SpanType.ClickableLegacy {
                        clickableArea.name()
                    },
                    textRange = TextRange(start = clickableArea.start, end = clickableArea.end),
                )
            )
        }
        return spannedRangeList
    }

    // ── Helpers ───────────────────────────────────────────────────────────────

    /**
     * Returns a Hebrew book name for a 1-based [bookIndex1Based] (same convention
     * as VerseItem.bookIndex and [PickVerseFromChapterUseCaseV2]'s bookIndex param).
     */
    private fun bookName(bookIndex1Based: Int): String =
        books.getOrNull(bookIndex1Based - 1)?.hebrew ?: ""

    /**
     * Strips the gershaim/colon wrapping added by withGershaimAndColon from
     * [VerseUiModel.text], returning the raw verse content (equivalent to the
     * former VerseItem.strPasukContent).
     */
    private fun VerseUiModel.rawContent(): String =
        text.removePrefix("\"").let { stripped ->
            val colonIdx = stripped.lastIndexOf(COLON_SPLITTER)
            if (colonIdx >= 0) stripped.removeRange(colonIdx, stripped.length).trimEnd('"')
            else stripped.trimEnd('"')
        }

    /**
     * Creates a minimal [VerseUiModel] to represent an error or empty-mikud state.
     * The [text] field carries the message displayed to the user.
     */
    private fun errorVerseUiModel(text: String): VerseUiModel = VerseUiModel(
        id = "error",
        text = text,
        source = "",
        highlightedRanges = persistentListOf(),
        bookIndex = 0,
        chapterIndex = 0,
        verse = "",
    )

}
